// extracted by mini-css-extract-plugin
export default {"my-wallet-page":"styles_my-wallet-page__qhGdy","myWalletPage":"styles_my-wallet-page__qhGdy"};